export default "__VITE_ASSET__C4026BPJ__"